import CreateQuotePage from './create-quote/CreateQuotePage';
import QuotePage from './quote/QuotePage';
import SendQuotePage from './send-quote/SendQuotePage';

export { CreateQuotePage, QuotePage, SendQuotePage };



// WEBPACK FOOTER //
// ./src/modules/quote/pages/index.js